module.exports = __webpack_public_path__ + "static/media/home-industrial-loaders.671485a7.jpg";